import { render, staticRenderFns } from "./UserSelectClauses.vue?vue&type=template&id=2adee3bf&scoped=true"
import script from "./UserSelectClauses.vue?vue&type=script&lang=js"
export * from "./UserSelectClauses.vue?vue&type=script&lang=js"
import style0 from "./UserSelectClauses.vue?vue&type=style&index=0&id=2adee3bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adee3bf",
  null
  
)

export default component.exports